import React from 'react';

import styles from './localizacao.module.scss';

const parse = require('html-react-parser');

export default function Localizacao({ data }) {
  if (!data) return null;
  const { localizacao, latitude, longitude } = data;

  return (
    <div className={styles.section}>
      <h2>Excelente localização</h2>
      {localizacao && <div className={styles.text}>{parse(localizacao)}</div>}
      {latitude && longitude && (
        <iframe
          loading='lazy'
          title='Mapa Empreendimento'
          src={`https://maps.google.com/maps?q=${`${latitude},${longitude}`}&output=embed`}
        />
      )}
    </div>
  );
}
